import React, { useState } from 'react';
import classNames from 'classnames/bind';
import { Container, Badge } from 'react-bootstrap';
import { Column } from 'react-table';
import { Table } from '../../components/DataTable';
import { toast } from 'react-toastify';
import api from '../../api';
import { FavoriteType } from '../../api/newApi/getFavoriteQuery'
import { useFavoriteInfo } from "../../hook/useFavoriteInfo"

import style from './index.module.css';
import OrderModel from '../../components/OrderModel';
import ShareModel from '../../components/ShareGuideModel';
import dayjs from "dayjs";



const cx = classNames.bind(style);

export interface SelfSelect {
  cuid: string,
  campaignName: string | null;
  sessionId: string | null;
  mtype: string;
  invitationCode: string | null;
  handleOninvitationCode: (code: string) => void,
  campaign_active: boolean,
  continueBell: () => void,
}




const SelfSelect: React.FC<SelfSelect> = ({
  cuid,
  campaignName,
  sessionId,
  mtype,
  invitationCode,
  handleOninvitationCode,
  campaign_active,
  continueBell
}) => {
  const Digits2NumberFormatter = (value: string) =>
    (+value).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  const Digits3NumberFormatter = (value: string) =>
    (+value).toLocaleString(undefined, {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    });

  const [retryToggle, setRetryToggle] = useState(false);
  const [favorite, setFavorite] = useState<any>(null);

  const getFavorite = useFavoriteInfo({ cu_id: cuid, retryToggle: retryToggle, sessionId: sessionId, mtype });
  const favoriteData = getFavorite.value ? getFavorite.value.favorites : []
  const favoritesCount = favoriteData?.length || 0
  const queryTime = getFavorite.value ? getFavorite.value.QueryTime : ""

  const [show, setShow] = useState(false);
  const [showinviteModel, setShowinviteModel] = useState(false);

  const [istop6K, setIstop6K] = useState<boolean | null>(null);
    //20230601開始活動 前500名獲得line points
  const [isPrize, setIsPrize] = useState<boolean | null>(null);
  // 母股漲停
  const [t_up_stop, setT_up_stop] = useState<number | null>(null)
  // 母股跌停
  const [t_down_stop, setT_down_stop] = useState<number | null>(null)
  //母股現價
  const [target_money, setTarget_money] = useState<string>('')
  // 優惠券

  const [symCnName, setSymCnName] = useState<string>("");
  const [sym, setSym] = useState<string>("");
  const [bS1, setBS1] = useState<"B" | "S" | null>(null);
  const [p1, setP1] = useState<number | null>(null);
  const [qty, setQty] = useState<number>(1);
  const [tif, setTif] = useState<"R" | "F" | "I" | null>(null);
  const [ort, setOrt] = useState<"1" | "2" | null>(null);
  const [t1, setT1] = useState<string>(dayjs().format("YYYY/MM/DD HH:mm:ss.000"))
  const [t2, setT2] = useState<string>("")

  React.useEffect(() => {
    const newData = favoriteData
    const data: any = []

    setFavorite(() => {
      return data.concat(newData)
    })
  }, [getFavorite])
  const handleClose = () => {
    setShow(false);
    setSymCnName("");
    setSym("");
    setBS1(null);
    setP1(null);
    setQty(1);
    setTif(null);
    setOrt(null);
    (window.parent as any).showBanner(1);
    setTimeout(() => {
      (window.parent as any).scrollTo({
        top: 0,
        behavior: 'smooth',
        scrollBehavior: 'smooth'
      });
    }, 100)

  };

  const handleOrder = (row: any) => {
    if (!campaign_active) {
      const t1 = dayjs().subtract(3, 'second').format("YYYY/MM/DD HH:mm:ss.000");
      const t2 = dayjs().format("YYYY/MM/DD HH:mm:ss.000");
      setT1(t1);
      setT2(t2);
      if (!campaign_active) {
        api.bellCheck({ cu_id: cuid, t1: t1, t2: t2 }).then((e) => {
          if (e?.err === "1200") {
            toast.warn('非系統交易時間！', {
              position: "top-right",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            return;
          } else {
            continueBell();
            setShow(true);
            setSymCnName(row.stock_name);
            setSym(row.stock_id);
            setP1(row.stock_money);
            setOrt("2");
            setTif("R")
            setT_up_stop(row.t_up_stop);
            setT_down_stop(row.t_down_stop);
            setTarget_money(row.target_money);
             (window.parent as any).showBanner(0);
             (window.parent as any).scrollTo({
               top: 11,
               behavior: 'smooth',
             });
          }
        })
      }
    } else {
      setShow(true);
      setSymCnName(row.stock_name);
      setSym(row.stock_id);
      setP1(row.stock_money);
      setOrt("2");
      setTif("R")
      setT_up_stop(row.t_up_stop);
      setT_down_stop(row.t_down_stop);
      setTarget_money(row.target_money);
      (window.parent as any).showBanner(0);
      (window.parent as any).scrollTo({
        top: 11,
        behavior: 'smooth',
      });
    }
  };

  const handlePrice = (price: number) => {
    setP1(price)
    setOrt("2")
  };

  const handlePriceType = (type: "1" | "2" | null) => {
    setOrt(type)
    if (type === "1") {
      setP1(0)
    }
  };

  const handleOrderPlace = () => {
    if (!bS1 || !tif || !ort || p1 == null) {
      toast.warn('請填妥下單條件', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return
    }
    if (ort === "2" && (!p1 || Number(p1) <= 0 || p1 <= 0)) {
      toast.warn('限價單請輸入價格', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return
    }

    api.OrderPlace({
      cu_id: cuid,
      src: "WEB",
      sym: sym,
      bS1: bS1,
      p1: p1,
      qty: qty,
      tif: tif,
      ort: ort,
      icc: invitationCode === null ? "1" : "0",

    }).then((e) => {
      handleClose()
      if (!e.inv_code) { return }
      if (e.inv_code) { handleOninvitationCode(e.inv_code) }
      if (e.top6K) {
        setIstop6K(e.top6K)
      }
      if (e.prize) {
        setIsPrize(e.prize)
      }
      setShowinviteModel(true);
      (window.parent as any).showBanner(0);
    })

  };


  const handleShareModelClose = () => {
    setShowinviteModel(false);
    (window.parent as any).showBanner(1);
  }

  const handleFavoriteRemove = (cuid: string, stock: string) => {
    api.favoriteRemove({
      cu_id: cuid, stock_id: stock
    }).then((e) => {
      if (e.err === "0000") {
        setRetryToggle(!retryToggle)
      }
    })

  };
  React.useEffect(() => { (window.parent as any).resizeIframe() }, [favorite])
  const columns = React.useMemo<Column<FavoriteType>[]>(
    () => [

      {
        Header: <><div className={cx("tablehaderWrap")}>選項</div></>,
        accessor: "action",
        sticky: "left",
        disableSortBy: true,
        Cell: cellInfo => <div className={cx("btnwrap")}>
          <button className={cx("btn", "order")} onClick={() => handleOrder(cellInfo.cell.row.original)}>下單</button>
          <button className={cx("btn", "del")} onClick={() => handleFavoriteRemove(cuid, cellInfo.cell.row.original.stock_id)}>移除</button>
        </div >
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>權證名稱</div></>,
        accessor: "stock_name",
        Cell: cellInfo => <>
          {<div>{cellInfo.cell.row.original.stock_name}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>權證代號</div></>,
        accessor: "stock_id",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{cellInfo.cell.row.original.stock_id}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>委買價(元)</div></>,
        accessor: "stock_buy",
        Cell: cellInfo => <>
          {<div className={cx("tablewrap",
            Number(cellInfo.cell.row.original.stock_buy) && Number(cellInfo.cell.row.original.ref_price) ?
              Number(cellInfo.cell.row.original.stock_buy) > Number(cellInfo.cell.row.original.ref_price) ? "red" :
                Number(cellInfo.cell.row.original.stock_buy) < Number(cellInfo.cell.row.original.ref_price) ? "green" : "" : ""
          )}>{Digits2NumberFormatter(cellInfo.cell.row.original.stock_buy)}</div>
          }
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>委賣價(元)</div></>,
        accessor: "stock_sale",
        Cell: cellInfo => <>
          {<div className={cx("tablewrap",
            Number(cellInfo.cell.row.original.stock_sale) && Number(cellInfo.cell.row.original.ref_price) ?
              Number(cellInfo.cell.row.original.stock_sale) > Number(cellInfo.cell.row.original.ref_price) ? "red" :
                Number(cellInfo.cell.row.original.stock_sale) < Number(cellInfo.cell.row.original.ref_price) ? "green" : "" : ""
          )}>{Digits2NumberFormatter(cellInfo.cell.row.original.stock_sale)}</div>
          }
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>權證價(元)</div></>,
        accessor: "stock_money",
        Cell: cellInfo => <>
          {<div className={cx("tablewrap",
            Number(cellInfo.cell.row.original.stock_money) && Number(cellInfo.cell.row.original.ref_price) ?
              Number(cellInfo.cell.row.original.stock_money) > Number(cellInfo.cell.row.original.ref_price) ? "red" :
                Number(cellInfo.cell.row.original.stock_money) < Number(cellInfo.cell.row.original.ref_price) ? "green" : "" : ""
          )}>{Number(cellInfo.cell.row.original.stock_money) ? Digits2NumberFormatter(cellInfo.cell.row.original.stock_money) : "--"}</div>
          }
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>漲跌%</div></>,
        accessor: "stock_percent",
        Cell: cellInfo => <>
          {<div className={cx("tablewrap", Number(cellInfo.cell.row.original.stock_percent) > 0 ? "red" :
            Number(cellInfo.cell.row.original.stock_percent) < 0 ? "green" : "")}>{Digits2NumberFormatter(cellInfo.cell.row.original.stock_percent)}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>標的價格</div></>,
        accessor: "target_money",
        Cell: cellInfo => <>
          {<div className={cx("tablewrap", Number(cellInfo.cell.row.original.target_percent) > 0 ? "red" :
            Number(cellInfo.cell.row.original.target_percent) < 0 ? "green" : "")}>{Digits2NumberFormatter(cellInfo.cell.row.original.target_money)}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>標的漲跌%</div></>,
        accessor: "target_percent",
        Cell: cellInfo => <>
          {<div className={cx("tablewrap", Number(cellInfo.cell.row.original.target_percent) > 0 ? "red" :
            Number(cellInfo.cell.row.original.target_percent) < 0 ? "green" : "")}>{Digits2NumberFormatter(cellInfo.cell.row.original.target_percent)}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>履約價</div></>,
        accessor: "run_money",
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{Digits2NumberFormatter(cellInfo.cell.row.original.run_money)}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>行使比例</div></>,
        accessor: "run_num",
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{Digits3NumberFormatter(cellInfo.cell.row.original.run_num)}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>價內外<br />程度%</div></>,
        accessor: "run_percent",
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{Number(cellInfo.cell.row.original.run_percent) > 0 ? "價內" : "價外"}{Math.abs(Number(cellInfo.cell.row.original.run_percent))}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>剩餘天數</div></>,
        accessor: "surplus_day",
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{cellInfo.cell.row.original.surplus_day}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>實質槓桿</div></>,
        accessor: "lever",
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{Digits2NumberFormatter(cellInfo.cell.row.original.lever)}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>買價波<br />動率%</div></>,
        accessor: "percent_buy",
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{Digits2NumberFormatter(cellInfo.cell.row.original.percent_buy)}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")}>價差比%</div></>,
        accessor: "diff_ratio",
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{Digits2NumberFormatter(cellInfo.cell.row.original.diff_ratio)}</div>}
        </>
      },
    ],
    [getFavorite]
  );
  return (
    <div className={cx("SelfWrap")}>
      <Container className={cx("container-left")} fluid="xl">
        <div className={cx("text-color", " container-left")}>
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="text-color bi bi-play" viewBox="0 0 16 16">
            <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
          </svg>
          目前盤別：{campaignName ? campaignName : "尚未選擇活動"}
        </div>
        <div className={cx("text-color", "container-left")}>
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className={cx("text-color", "bi", "bi-play")} viewBox="0 0 16 16">
            <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
          </svg>
          自選清單  <Badge className={cx("badge-box")}>{favoritesCount}筆</Badge>
        </div>
        <div className={cx("updateTime")}>
          更新時間：{queryTime || ""}
        </div>
        <div className={cx('tableHead-minHeight')}><Table columns={columns} data={favorite || []} pagination={true} loading={getFavorite.loading} /></div>
        <ul className={cx("list-dot", "text-secondary", "small")}>
          <li>
            註: 剩餘天數以日曆日計算。
          </li>
          <li>
            註: 委買隱含波動率為權證買價所反推之隱含波動率，非發行商之造市波動率。
          </li>
        </ul >
        <OrderModel
          isOpen={show}
          mtype={mtype}
          sessionId={sessionId}
          handleClose={handleClose}
          symCnName={symCnName}
          handleSymCnName={(name) => { setSymCnName(name) }}
          sym={sym}
          handleSym={(sym) => { setSym(sym) }}
          buyOrSell={bS1}
          handleBuyOrSell={(bs) => { setBS1(bs) }}
          orderPriceType={ort}
          handleOrderPriceType={(type) => { handlePriceType(type) }}
          orderTime={tif}
          handleOrderTime={(tif) => { setTif(tif) }}
          price={p1 || 0}
          handleOrderPrice={(price) => { handlePrice(price) }}
          qty={qty || 0}
          handleOrderQty={(qty) => { setQty(qty) }}
          handleOrderPlace={() => { handleOrderPlace() }}
          target_money={target_money}
          target_upprice={t_up_stop}
          target_downprice={t_down_stop}

        />
        <ShareModel
          isOpen={showinviteModel}
          handleClose={() => { handleShareModelClose() }}
          istop6K={istop6K}
          invitationCode={invitationCode}
          isPrize={isPrize}
        />
      </Container >
    </div>
  );
};


export default SelfSelect;
